import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgXMark = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 11,
	viewBox: "0 0 12 11",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.7812 1.78125L7.03125 5.53125L10.75 9.25C11.0625 9.53125 11.0625 10 10.75 10.2812C10.4688 10.5938 10 10.5938 9.71875 10.2812L5.96875 6.5625L2.25 10.2812C1.96875 10.5938 1.5 10.5938 1.21875 10.2812C0.90625 10 0.90625 9.53125 1.21875 9.21875L4.9375 5.5L1.21875 1.78125C0.90625 1.5 0.90625 1.03125 1.21875 0.71875C1.5 0.4375 1.96875 0.4375 2.28125 0.71875L6 4.46875L9.71875 0.75C10 0.4375 10.4688 0.4375 10.7812 0.75C11.0625 1.03125 11.0625 1.5 10.7812 1.78125Z",
		fill: "white"
	})
});
export { SvgXMark as ReactComponent };
